import React from "react";
import StdRTGS from "../../components/StudentTabs/StudentRTGS/StdRTGS"

const RTGSDetails= () => {
  return (
    <div>
      
      <StdRTGS/>
    </div>
  );
};

export default RTGSDetails;